export default __webpack_public_path__ + "static/media/83.141b5cd8.jpg";